import { jsx as _jsx } from "react/jsx-runtime";
import { useState, useEffect, useRef } from 'react';
/**
 * The CMS stores an autocomplete token per input, and two of them are not
 * valid HTML autofill values: `phone` (the token is `tel`) and `details` (no
 * token describes a free-text enquiry, so the attribute is better left off).
 * Browsers quietly ignore an unknown value; an accessibility audit reports it.
 * Correcting here rather than only in WordPress keeps a future typo in the
 * field from reaching the markup.
 */
const AUTOCOMPLETE_CORRECTIONS = {
    phone: 'tel',
    details: undefined,
};
const validAutocomplete = (token) => token && token in AUTOCOMPLETE_CORRECTIONS
    ? AUTOCOMPLETE_CORRECTIONS[token]
    : token;
export const TextInput = ({ setup, error, allowOpen, }) => {
    const { autocomplete, id, mandatory, name, is_input_area } = setup;
    const [showError, setShowError] = useState(false);
    const inputRef = useRef(null);
    useEffect(() => {
        if (error) {
            setShowError(true);
        }
    }, [error]);
    useEffect(() => {
        if (allowOpen === false && inputRef.current) {
            inputRef.current.blur();
        }
    }, [allowOpen]);
    const onChange = (evt) => {
        if (showError) {
            setShowError(false);
        }
    };
    const InputComponent = is_input_area ? 'textarea' : 'input';
    return (_jsx("div", { className: "text-input-container", children: _jsx(InputComponent, { className: `text-input${showError ? ' error' : ''}${is_input_area ? ' textarea' : ''}`, name: id, type: "text", placeholder: `${name}${mandatory ? '*' : ''}`, autoComplete: validAutocomplete(autocomplete), onChange: onChange, ref: (ref) => (inputRef.current = ref) }) }));
};
